export default __webpack_public_path__ + "static/media/Payment-Details.01ccdbb4.jpg";